import { inject } from '@angular/core';
import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CancelOrderAction } from '@support/states/support/support.actions';
import { Store } from '@ngxs/store';
import { IceButtonComponent } from '@app/shared/components/atoms/ice-button/ice-button.component';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
  selector: 'app-cancel-order-dialog',
  templateUrl: './cancel-order-dialog.component.html',
  styleUrls: ['./cancel-order-dialog.component.scss'],
  imports: [
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatDialogActions,
    IceButtonComponent,
    MatDialogClose,
  ],
})
export class CancelOrderDialogComponent {
  private store = inject(Store);
  dialogRef = inject<MatDialogRef<CancelOrderDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA, { optional: true });

  orderServiceId: number;
  form: FormGroup = new FormGroup({
    reason: new FormControl('', [Validators.required, Validators.maxLength(200)]),
  });

  constructor() {
    this.orderServiceId = this.data.orderServiceId;
  }

  cancelOrder() {
    this.store.dispatch(new CancelOrderAction(this.orderServiceId, this.form.controls.reason.value));
    this.dialogRef.close();
  }

  abort() {
    this.dialogRef.close();
  }
}
